import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { VariaveisAmbiente } from 'config';


export function usePostIdentidadeRefreshToken() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postIdentidadeRefreshToken = useCallback(
        (tokenAtual: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/identidade/refresh-token`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: `${tokenAtual}`,
                enviarTokenUsuario: false
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postIdentidadeRefreshToken,
    };
}
